// pages/FormViewerPage/services/formViewerService/coupon.ts — Logika diskon kupon (pure).
// Diskon diambil dari SUBTOTAL PRODUK saja (bukan ongkir/COD). Total tidak boleh 0:
// sisa minimal Rp 1. Rumus ini MIRROR dari cap di RPC submit_public_order.
export function computeDiscountAmount(
    rawDiscount: number,
    subtotalLine: number,
    shippingCost: number,
    codFee: number,
): number {
    const raw = Math.max(0, Math.round(Number(rawDiscount) || 0));
    const subtotal = Math.max(0, Math.round(Number(subtotalLine) || 0));
    if (raw <= 0 || subtotal <= 0) return 0;
    const ship = Number(shippingCost) || 0;
    const cod = Number(codFee) || 0;
    let discount = Math.min(raw, subtotal);
    if (subtotal - discount + ship + cod < 1) {
        discount = Math.max(0, Math.round(subtotal + ship + cod - 1));
    }
    return discount;
}
